module.exports = __webpack_public_path__ + "img/ic-expertise-essilor-64.39ecd444.svg";